/*
 * @Author: your name
 * @Date: 2021-04-13 20:44:52
 * @LastEditTime: 2022-08-06 22:34:02
 * @LastEditors: yanglq-PC 61739363@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\api\goodsAPI.js
 */
import axios from 'axios';
import { ServerPath } from '@/config/serverPath';

/**
 * @name: 获取首页所有商品信息
 * @msg: 无
 * @return {*}
 */
 export async function index_goods() {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/index_goods.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 获取排行榜商品信息
 * @msg: 无
 * @return {*}
 */
 export async function leaderBoard(type) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/leader_board.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
        params: {
            type: type,
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 商品筛选页面的商品数据
 * @msg: 无
 * @param {*} list_id       列表ID
 * @param {*} classify_id   分类ID
 * @param {*} brand_id      品牌ID
 * @param {*} page          页码
 * @param {*} page_num      每页个数
 * @return {*}
 */
 export async function filter_goods(list_id, classify_id, brand_id, page, page_num) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/filter_goods.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
        params: {
            list_id: list_id,
            classify_id: classify_id,
            brand_id: brand_id,
            page: page,
            page_num: page_num,
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 商品搜索页面的商品数据
 * @msg: 无
 * @param {*} search       搜索名称
 * @param {*} page          页码
 * @param {*} page_num      每页个数
 * @return {*}
 */
 export async function search_goods(search, page, page_num) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/search_goods.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
        params: {
            search: search,
            page: page,
            page_num: page_num,
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 商品详情页数据
 * @msg: 无
 * @param {*} id    商品ID
 * @return {*}
 */
 export async function goods_info(id) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/goods_info.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
        params: {
            id: id,
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 获取购物车数据
 * @msg: 无
 * @return {*}
 */
 export async function getCartData() {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/cart.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 获取订单列表数据
 * @msg: 无
 * @param {*} status    订单状态
 * @param {*} page      页码
 * @param {*} page_num  每页个数
 * @return {*}
 */
 export async function getOrderList(status, page, page_num) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/order_list.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
        params: {
            status: status,
            page: page,
            page_num: page_num,
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 获取订单商品数据
 * @msg: 无
 * @param {*} id    订单ID
 * @return {*}
 */
 export async function getOrderGoods(id) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/order_goods.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
        params: {
            id: id,
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 获取会员首页信息
 * @msg: 无
 * @return {*}
 */
 export async function getCenterInfo() {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/center_info.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 获取会员我的价格商品信息
 * @msg: 无
 * @return {*}
 */
 export async function getMyPrice(page, page_num) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/my_price.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
        params: {
            page: page,
            page_num: page_num,
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}